import {
  SearchAPIConfig,
  SearchAPISearchResponse,
  SearchAPISearchResults,
} from "./types";
import { removeEmptyKeys } from "@helpers/utils";

class SearchAPIQueryHandler {
  private config: SearchAPIConfig;

  constructor(config: SearchAPIConfig) {
    this.config = config;
  }

  public async executeSearch(
    searchQuery: string,
  ): Promise<SearchAPISearchResults> {
    if (
      !searchQuery ||
      typeof searchQuery !== "string" ||
      searchQuery.length < 3
    ) {
      throw new Error(
        "Search query must be a non-empty string with at least 3 characters.",
      );
    }

    const searchUrl = this.getSearchUrl(searchQuery);
    try {
      const response = await fetch(searchUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const searchResponse: SearchAPISearchResponse = await response.json();
      const searchResults = removeEmptyKeys(searchResponse.resources.results);
      return searchResults;
    } catch (error) {
      console.error("Error fetching data: ", error);
      throw error;
    }
  }

  private getSearchUrl(searchQuery: string): string {
    let searchUrl = `/search/suggest.json?q=${searchQuery}`;
    const { resources, limit, unavailable_products, fields } =
      this.config.SearchAPISearchOptions;

    if (resources) {
      searchUrl += `&resources[type]=${resources.join(",")}`;
    }
    if (limit) {
      searchUrl += `&resources[limit]=${limit}`;
    }
    if (unavailable_products) {
      searchUrl += `&resources[unavailable_products]=${unavailable_products}`;
    }
    if (fields) {
      searchUrl += `&resources[fields]=${fields.join(",")}`;
    }

    return searchUrl;
  }
}

export default SearchAPIQueryHandler;
